<template>
  <div class="loading-warp" v-show="showLoading">
    <img :src="loadingIcon" >
  </div>
</template>

<script>
  import loadingIcon from '../assets/icon/icon-loading.png'
  export default {
    name: "Loading",
    props:{
      showLoading:false,
    },
    data() {
      return {
        loadingIcon,
      }
    }
  }
</script>

<style scoped lang="less">
  .loading-warp{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.50);
    z-index: 10;
    img {
      -webkit-animation: 1s loader linear infinite;
      animation: 1s loader linear infinite;
      width: 32px;
      height: 32px;
    }
    @-webkit-keyframes loader {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
    @keyframes loader {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }


</style>